<template>
  <div
    class="label-field"
    :class="[wrapperStyle.class]"
    :style="[wrapperStyle.style]"
    :ref="name"
  >
    <component :is="addonComponent"> </component>
    <div
      :id="`${name}_${type}`"
      v-if="showLabel"
      :class="[fieldStyle.class, type]"
      :style="[fieldStyle.style]">   
        <span  class="left" v-html="label"></span>
        <span class="badge new left accent-3 core" :data-badge-caption="badge" v-if="badge"></span>
      <a href="#" 
      v-if="helperVideo" v-tipped 
      :data-tooltip="helperVideo.tooltip"
      :helper-id="helperVideo.helperId"
      data-position="left"
        class="btn-floating btn-small red waves-effect right">
        <i class="material-icons white-text">
          play_arrow
        </i>
      </a>
    </div>
   
  </div>
</template>

<script>
export default {
  name: "LabelField",
  props: {
    value: {
      type: [String, Number],
    },
    helperVideo:{
      type: [Object, Boolean],
      default: false
    },
    badge: {
      type:[Boolean, String, Number],
      default: false,
    },
    addonComponent: {
      type: [String, Object],
      default: "div",
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    fieldType: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    helperText: {
      type: String,
      required: false,
      default: "",
    },
    autoComplete: {
      type: Boolean,
      default: () => true,
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    fieldStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    icon: {
      type: String,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
    groupTag: {
      type: String,
      default: () => "",
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      reuqired: false,
    },
  },

  data() {
    return {
      isTyping: false,
      fieldValue: this.value,
    };
  },
  mounted() {
    this.addToGroup();
  },
  watch: {
    fieldValue: function() {
      this.allowOnlyNumber();
      this.updateValue();
    },
  },
  computed: {
    displayError() {
      if (this.isTyping) {
        if (this.hasError && this.error) {
          return "invalid";
        } else {
          return "valid";
        }
      }
    },
  },
  methods: {
    addToGroup() {
      if (this.groupTag) {
        const groupId = `#${this.groupTag}`;
        const contentContainerId = `#${this.groupTag}_content`;
        // console.log(`${this.name} => belongs to ${this.groupTag} group`);

        const group = document.querySelector(groupId);

        const contentContainer = document.querySelector(contentContainerId);

        const groupItem = this.$refs[this.name];

        if (contentContainer) {
          contentContainer.appendChild(groupItem);
        } else {
          group.appendChild(groupItem);
        }
      }
    },
    // addPlaceholder() {
    //   if (this.placeholder) {
    //     const el = this.$el.querySelector(`#${this.name.toLowerCase()}`);
    //     el.placeholder = this.placeholder;
    //   }
    // },
    allowOnlyNumber() {
      if (this.fieldType === "number") {
        this.fieldValue = this.fieldValue.replace(/[^0-9]/g, "");
      }
    },
    updateValue(event) {
      this.isTyping = true;
      // console.log(error, hasError);
      this.$emit("update", this.fieldValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.label-field {
  margin-bottom: 8px;
  .desc {
    width: 100%;
  }
  .desc,
  .description {
    font-size: 15.6px;
  }
/*   .main-question {
  } */
  .sized-label {
    font-size: 20px;
    margin-bottom: 8px;
  }
  .badge {
    font-weight: 400 !important;
    letter-spacing: .7px; 
    &.core {
     &::before {
        content: 'star';
        font-family: 'Material Icons Outlined';
        display: inline-block;
        line-height: 14px;
        transform: translateY(1px);
     }
    }
  }
.boxed-content {
    margin: 12px 0px 24px;
    font-size: 16px !important;
    line-height: 24px !important;
    padding: 24px;
    border-radius: 7px;
    background: #ffffff;
    position: relative;
/*     &::before {
      content: 'help_outline';
      position: absolute;
      left: 12px;
      font-family: 'Material Icons Outlined';
      font-size: 34px;
      top: 28px;
    } */
  }
}

</style>
